import { createContext } from "use-context-selector"

import { createProvider } from "domain/createProvider"
import { TDictionariesInitState } from "domain/globalConfig/dictionary/types"
import { TWebhookEventsInitState } from "domain/globalConfig/userGroups/types"
import { TUserGroupsInitState } from "domain/globalConfig/webhook/types"

export type TGlobalConfigContextState = {
  dictionaries: TDictionariesInitState
  webhookEvents: TWebhookEventsInitState
  userGroups: TUserGroupsInitState
  update?: (state: Partial<TGlobalConfigContextState>) => void
}

const initState: TGlobalConfigContextState = {
  dictionaries: {
    countries: null,
    cryptoAssets: null,
    currencies: null,
    operations: null,
    paymentMethods: null,
    paymentSystemStatuses: null,
    paymentSystemSubmethods: null,
    transactionStatuses: null,
    types: null,
    sources: null,
  },
  webhookEvents: null,
  userGroups: null,
}

export const GlobalConfigContext = createContext(initState)

export const GlobalConfigProvider = createProvider(
  GlobalConfigContext,
  initState
)
